import { useUnreads } from '@talkjs/react'

export function useConversationUnreads(conversationId?: string) {
  const unreads = useUnreads()

  if (!unreads || !conversationId) {
    return []
  }

  return unreads.filter(unread => unread.conversation.id === conversationId)
}
